import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { EnvironmentModel } from './environment.model'

export const environment: EnvironmentModel = {
    modules: {
        AnimationsModule: BrowserAnimationsModule,
    },
}
